import React, { useEffect, useMemo } from "react";
import "../../styles/TicketSelection.scss";

interface Props {
  event: any;
  selectedDate: string;
  setSelectedDate: (date: string) => void;
  selectedTicket: any;
  setSelectedTicket: (ticket: any) => void;
  quantity: number;
  setQuantity: (num: number) => void;
}

const TicketSelection: React.FC<Props> = ({
  event,
  selectedDate,
  setSelectedDate,
  selectedTicket,
  setSelectedTicket,
  quantity,
  setQuantity,
}) => {
  const allDates = event.all_dates || [];

  useEffect(() => {
    if (allDates.length > 0 && !selectedDate) {
      setSelectedDate("all_dates");
    }
  }, [allDates, selectedDate, setSelectedDate]);

  const availableTickets = selectedDate ? event.tickets || [] : [];

  const formatDateRange = useMemo(() => {
    if (!allDates.length) return "";

    const sortedDates = [...allDates].sort(
      (a: string, b: string) =>
        new Date(a).getTime() - new Date(b).getTime()
    );

    const firstDate = new Date(sortedDates[0]);
    const lastDate = new Date(sortedDates[sortedDates.length - 1]);

    const formatFullDate = (date: Date) =>
      date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });

    return `${formatFullDate(firstDate)} - ${formatFullDate(lastDate)}`;
  }, [allDates]);

  return (
    <div className="ticket-selection">
      <h4>Registration Fee</h4>

      <div className="date-section">
        <p>Date:</p>
        <div className="radio-group">
          {allDates.length > 0 && (
            <label className="radio-item">
              <input
                type="radio"
                name="date"
                value="all_dates"
                checked={selectedDate === "all_dates"}
                onChange={() => {
                  setSelectedDate("all_dates");
                  setSelectedTicket(null);
                }}
              />
              <span>May 27, 2027 - May 29, 2027</span>
              {/* <span>{formatDateRange}</span> */}
            </label>
          )}
        </div>
      </div>

      {selectedDate && (
        <div className="ticket-type-section">
          <p>Ticket Type:</p>
          <div className="radio-group">
            {availableTickets.length > 0 ? (
              availableTickets.map((ticket: any) => (
                <label key={ticket.id} className="radio-item">
                  <input
                    type="radio"
                    name="ticket"
                    value={ticket.id}
                    checked={selectedTicket?.id === ticket.id}
                    onChange={() => setSelectedTicket(ticket)}
                  />
                  <span>
                    {ticket.name} - ₱
                    {Number(ticket.ticket_price).toLocaleString()} (
                    {ticket.capacity - ticket.ticket_count} slots)
                  </span>
                </label>
              ))
            ) : (
              <p className="no-ticket">No tickets available.</p>
            )}
          </div>
        </div>
      )}

      {selectedTicket && (
        <div className="quantity-section">
          <p>Quantity:</p>
          <div className="quantity-control">
            <button
              type="button"
              onClick={() => setQuantity(Math.max(1, quantity - 1))}
            >
              −
            </button>
            <span>{quantity}</span>
            <button type="button" onClick={() => setQuantity(quantity + 1)}>
              +
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TicketSelection;